/**
 * #4447 GUSSTATION: the one strip a PIN session shows on every page: who is
 * at the station, and Switch person. Rendered only when /api/rbac/me says the
 * session was minted by a PIN (the server's mark, not a client flag). The
 * idle timer lives here so it runs wherever the person navigates.
 */
import { ArrowRightLeft } from "lucide-react";
import { usePinSession } from "@/hooks/use-rbac";
import { useIdleSwitch } from "@/hooks/use-idle-switch";
import { useSession } from "@/lib/auth-client";
import { switchPerson } from "@/lib/station-client";

export function PinSessionChrome() {
  const pin = usePinSession();
  const { data: session } = useSession();
  useIdleSwitch(pin !== null);
  if (!pin) return null;
  const name = session?.user?.name || session?.user?.email || "Signed in";
  return (
    <div
      role="status"
      className="flex h-11 shrink-0 items-center gap-3 border-b border-border bg-muted/40 px-4 text-sm lg:px-6 print:hidden"
    >
      <p className="min-w-0 flex-1 truncate">
        <span className="font-medium text-foreground">{name}</span>
        <span className="text-muted-foreground"> at {pin.station_name}</span>
      </p>
      <button
        type="button"
        onClick={() => void switchPerson()}
        className="inline-flex h-9 shrink-0 items-center gap-2 rounded-md bg-primary px-3 text-sm font-medium text-primary-foreground hover:bg-primary/90"
      >
        <ArrowRightLeft className="h-4 w-4" aria-hidden="true" />
        Switch person
      </button>
    </div>
  );
}
